import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import './LanguageSelector.css';

// Import flag icons
// These should be added to your project in the public folder or in src/components/images
// You can use SVGs from sources like https://flagicons.lipis.dev/
import romaniaFlag from './images/flags/ro.svg';
import ukFlag from './images/flags/gb.svg';

const LanguageSelector = () => {
  const { language, changeLanguage, t } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Toggle dropdown
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Handle language change
  const handleLanguageChange = (lang) => {
    changeLanguage(lang);
    setIsOpen(false);
  };

  // Get current flag
  const getCurrentFlag = () => {
    return language === 'ro' ? romaniaFlag : ukFlag;
  };

  return (
    <div className="language-selector" ref={dropdownRef}>
      <button 
        className="language-btn" 
        onClick={toggleDropdown}
        aria-label="Change language"
      >
        <img 
          src={getCurrentFlag()} 
          alt={language === 'ro' ? 'Romanian flag' : 'UK flag'} 
          className="flag-icon"
        />
      </button>
      
      {isOpen && (
        <div className="language-dropdown">
          <button 
            className={`dropdown-item ${language === 'ro' ? 'active' : ''}`}
            onClick={() => handleLanguageChange('ro')}
          >
            <img src={romaniaFlag} alt="Romanian flag" className="flag-icon" />
            <span>{t('language.ro')}</span>
          </button>
          <button 
            className={`dropdown-item ${language === 'en' ? 'active' : ''}`}
            onClick={() => handleLanguageChange('en')}
          >
            <img src={ukFlag} alt="UK flag" className="flag-icon" />
            <span>{t('language.en')}</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector; 